import PropTypes from 'prop-types';
import Barcode from 'react-barcode';
import useLiterals from 'utils/hooks/useLiterals';
import { isValidPaymentBarcodeReference } from 'utils/paymentBarcodeReference';
import './styles.scss';

/**
 * Icono de marco de escaneo (estilo resumen de pago).
 */
const ScanFrameIcon = () => (
  <svg
    className='payment-summary-barcode__icon'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M2 6V3.5C2 2.67 2.67 2 3.5 2H6M12 2H14.5C15.33 2 16 2.67 16 3.5V6M16 12V14.5C16 15.33 15.33 16 14.5 16H12M6 16H3.5C2.67 16 2 15.33 2 14.5V12'
      stroke='currentColor'
      strokeWidth='1.75'
      strokeLinecap='round'
    />
  </svg>
);

/**
 * @param {number} length
 * @returns {number}
 */
const getBarcodeModuleWidth = (length) => {
  if (length > 28) return 0.9;
  if (length > 20) return 1.15;
  return 1.6;
};

/**
 * Código de barras Code128 para el resumen de pago.
 */
const PaymentSummaryBarcode = ({ reference, validateFormat }) => {
  const literals = useLiterals('contractPay');
  const barcodeLiterals = literals.paymentSummaryBarcode || {};

  if (!reference) return null;
  if (validateFormat && !isValidPaymentBarcodeReference(reference)) {
    return null;
  }

  const referenceValue = String(reference);
  const isLongReference = referenceValue.length > 20;

  return (
    <div id='payment-summary-barcode' className='payment-summary-barcode'>
      <div className='payment-summary-barcode__header'>
        <ScanFrameIcon />
        <span className='payment-summary-barcode__label'>
          {barcodeLiterals.scanLabel}
        </span>
      </div>
      <div className='payment-summary-barcode__canvas'>
        <Barcode
          className='payment-summary-barcode__image'
          format='CODE128'
          height={72}
          margin={0}
          width={getBarcodeModuleWidth(referenceValue.length)}
          displayValue={false}
          value={referenceValue}
          background='#ffffff'
          lineColor='#000000'
        />
      </div>
      <p
        className={
          isLongReference
            ? 'payment-summary-barcode__value payment-summary-barcode__value--long mb-0'
            : 'payment-summary-barcode__value mb-0'
        }
      >
        {referenceValue}
      </p>
    </div>
  );
};

PaymentSummaryBarcode.propTypes = {
  reference: PropTypes.string,
  validateFormat: PropTypes.bool,
};

PaymentSummaryBarcode.defaultProps = {
  reference: null,
  validateFormat: true,
};

export default PaymentSummaryBarcode;
